import { Alert, Box } from 'braid-design-system';
import React, { type ReactNode } from 'react';

export interface Props {
  children?: ReactNode;
  hasError: boolean;
}

const PageErrorMessage = ({ children, hasError }: Props) =>
  hasError ? (
    <Box marginY="medium">
      <Alert tone="critical">{children}</Alert>
    </Box>
  ) : null;

export default PageErrorMessage;
